const LoaderView = () => {
  return (
    <div className="top-0 z-50 absolute w-full flex justify-center items-center bg-[white] h-[100vh] bg-opacity-50">
      <div
        className="h-[200px] w-[200px] flex justify-center items-center "
        //   onClose={() => setOpen(false)}
      >
        <div
          className="inline-block h-16 w-16 animate-spin rounded-full border-indigo-800 border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></div>
      </div>
    </div>
  );
};

export default LoaderView;
